<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" label-width="80px">
      <el-row>
        <el-col :span="10" :offset="2">
          <el-form-item label="品牌:">
            <el-radio-group v-model.number="searchForm.brand_id" @change="checkInput">
              <el-radio :label="1">N牌</el-radio>
              <el-radio :label="2">S牌</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="日期:">
            <el-date-picker v-model="searchForm.day" type="date"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" :offset="2">
          <el-form-item label="會員:">
            <el-input
              v-model="searchForm.memberName"
              style="width: 50%"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="店櫃:">
            <el-select v-model="searchForm.shopKey" filterable>
              <el-option
                v-for="item in shopList"
                :label="item.name"
                :value="item._key"
                :key="item._key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" :offset="2">
          <el-form-item label="狀態:">
            <el-radio-group v-model.number="searchForm.status">
              <el-radio :label="1">完成</el-radio>
              <el-radio :label="2">作廢</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="單號:">
            <el-input v-model="searchForm.id" style="width: 50%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="2">
          <el-button type="primary" icon="el-icon-search" @click="fetchOrderList"
            >查詢</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :lg="6" :offset="18">
        <el-button type="primary" @click="dialogFormVisible = true">報表</el-button>
        <el-dialog title="報表" :visible.sync="dialogFormVisible" width="40%" center>
          <el-form :model="excelForm" :rules="rules" ref="excelForm" label-width="90px">
            <el-row justify="center" align="center">
              <el-col :span="22" :offset="2">
                <el-form-item label="品牌:" prop="brand_id">
                  <el-radio-group
                    v-model.number="excelForm.brand_id"
                    @change="excelCheckInput"
                  >
                    <el-radio :label="1">N牌</el-radio>
                    <el-radio :label="2">S牌</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
                <el-col :span="22" :offset="2">
          <el-form-item label="訂單種類:">
            <el-radio-group v-model.number="excelForm.type">
              <el-radio :label="1">產品訂單</el-radio>
              <el-radio :label="2">電子錢包訂單</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
              <el-col :span="22" :offset="2">
                <el-form-item label="日期間格:">
                  <el-date-picker
                    v-model="excelForm.date"
                    type="daterange"
                    range-separator="到"
                    start-placeholde="開始日期"
                    end-placeholde="結束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="22" :offset="2">
                <el-form-item label="店櫃:">
                  <el-select v-model="excelForm.shopKey" filterable>
                    <el-option
                      v-for="item in excelShopList"
                      :label="item.name"
                      :value="item._key"
                      :key="item._key"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-progress :text-inside="true" :stroke-width="26" :percentage="percentData" v-if="start"></el-progress>
          
         
          <el-row justify="center" align="center"> </el-row>

          <span slot="footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="downExcel('excelForm')">匯 出</el-button>
          </span>
        </el-dialog>
        
      </el-col>
    </el-row>

    <el-row>
      <el-col :lg="22" :offset="1">
        <el-table
          :data="orderList.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
          :header-cell-style="tableHeaderColor"
          empty-text="暫無數據"
          style="width: 100%"
        >
          <el-table-column prop="create_datetime" label="訂單日期"> </el-table-column>
          <el-table-column prop="id" label="訂單編號"> </el-table-column>
          <el-table-column prop="shop_name" label="店櫃"> </el-table-column>
          <el-table-column prop="member_name" label="會員"> </el-table-column>
          <el-table-column prop="total" label="金額"> </el-table-column>
          <el-table-column label="狀態">
            <template slot-scope="scope">
              <el-tag type="info">
                {{ scope.row.status == 1 ? "完成" : null }}
                {{ scope.row.status == 2 ? "廢止" : null }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="詳細">
            <template slot-scope="scope">
              <el-button
                type="info"
                icon="el-icon-more"
                @click="detailTabs(scope.$index, scope.row)"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total1"
          @current-change="current_change"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import toExcel from "@/excel/json2excel";
export default {
  name: "search",
  data() {
    return {
      searchForm: {
        id: "",
        brand_id: null,
        day: "",
        shopKey: "",
        memberName: "",
        status: null,
      },
      orderList: [],
      orderExcel: [],
      memberList: [],
      productDetail: {},
      shopList: [],
      excelShopList: [],
      typeName: "",
      memberName: "",
      shopName: "",
      member: [],
      shop: [],
      type: [],
      types: [],
      itemName: "",
      itemQty: "",
      itemId: "",
      itemPrice: "",
      items: [],
      excelForm: {
        brand_id: 1,
        date: [],
        shop_key: "",
        type: 1,
      },
      total1: 0,
      currentPage: 1,
      pagesize: 10,
      orderKey: "",
      strDay: "",
      bid: {},
      excelBrandId: {},
      start: false,
      percentData:0,
      dialogVisible: false,
      dialogFormVisible: false,
      option: [
        {
          label: "N牌",
          value: 1,
        },
        {
          label: "S牌",
          value: 2,
        },
      ],
      rules: {
        brand_id: [{  required: true,
                                message: '請選擇品牌',
                                trigger: 'change'}],
      },
    };
  },
  computed: mapGetters([
    "getOrderList",
    "getMemberList",
    "getShopList",
    "getMemberDetail",
    "getShopDetail",
    "getOrderExcel",
    "getProductDetail",
  ]),
  methods: {
    ...mapActions([
      "fetchOrderList",
      "fetchMemberList",
      "fetchShopList",
      "fetchMemberDetail",
      "fetchShopDetail",
      "fetchOrderExcel",
      "fetchProductDetail",
    ]),
    async fetchOrderList() {
      if (this.day != null) {
        this.strDay = moment(this.day).format("YYYY-MM-DD");
      } else {
        this.strDay = null;
      }
      const data = {
        id: this.searchForm.id,
        brand_id: this.searchForm.brand_id,
        day: this.strDay,
        shop_key: this.searchForm.shopKey,
        member_name: this.searchForm.memberName,
        status: this.searchForm.status,
      };
      await this.$store.dispatch("fetchOrderList", data);

      this.orderList = await this.getOrderList;
      this.total1 = await this.orderList.length;
    },

    async fetchShopList() {
      if (this.searchForm.brand_id != 0) {
        this.bid = {
          brand_id: this.searchForm.brand_id,
        };
      } else {
        this.bid = {};
      }
      
      await this.$store.dispatch("fetchShop", this.bid);
      this.shopList = this.getShopList;
      
    },

     async excelQueryShop() {
      
      if (this.excelForm.brand_id != null) {
        this.excelBrandId = {
          brand_id: this.excelForm.brand_id,
        };
      } else {
        this.excelBrandId = {};
      }
      
      await this.$store
        .dispatch("fetchShop", this.excelBrandId)
        .then(() => {
          this.excelShopList = this.getShopList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async downExcel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
         return this.allowExcel()
         
        }else {
          return   this.$notify({
                    title: '提示',
                    message: '請輸入必要欄位',
                    type: 'danger',
                    duration: '4500',
                    position: 'top-right'
                });
        }
      })
     
    },
  

   async allowExcel(){
     this.start = true;
      await this.$message({
        type: 'info',
        message: '完成需等待時間完成匯出',
      })
      this.percents()
      
        if (this.excelForm.date.length != 0) {
        this.startDay = moment(this.excelForm.date[0]).format("YYYY-MM-DD");
        this.endDay = moment(this.excelForm.date[1]).add(1, 'day').format("YYYY-MM-DD");
      } else {
        this.startDay = "";
        this.endDay = "";
      }
      const data = {
        brand_id: this.excelForm.brand_id,
        start_date: this.startDay,
        end_date: this.endDay,
        shop_key: this.excelForm.shopKey,
        type: this.excelForm.type,
      };
      await this.$store.dispatch("fetchOrderExcel", data);

      this.orderExcel = this.getOrderExcel;

     

      this.DataExcel(this.excelForm.type,this.orderExcel, this.startDay, this.endDay, this.excelForm.brand_id);
     
     this.start = false;
    },
    percents(){
        this.percentData += 20
        var self = this;
        setTimeout(function () {
          self.percentData += 20
        }, 10000)
        setTimeout(function () {
          self.percentData += 20
        }, 20000)
        setTimeout(function () {
          self.percentData += 20
        }, 30000)
        setTimeout(function () {
          self.percentData += 20
        }, 40000)
        
    
       
    },

    async DataExcel(type ,datas, statDay, endDay, brand_id) {
      console.log(type);
     if (type == 1) {
        const th = [
        "會員卡號",
        "會員姓名",
        "店櫃代碼",
        "店櫃名稱",
        "訂單日期時間",
        "訂單單號",
        "品號",
        "商品種類",
        "系列別",
        "組合或任搭品號",
        "品名",
        "組合或任搭名稱",
        "銷售數量",
        "單價",
        "小計"
        
      ];
      const filterVal = [
        "card_number",
        "member_name",
        "shop_id",
        "shop_name",
        "create_datetime",
        "id",
        "item_id",
        "item_type",
        "class_name",
        "pack_id",
        "item_name",
        "pack_name",
        "item_qty",
        "item_price",
        "pack_paid",
        
      ];
      const data = datas.map((v) => filterVal.map((k) => v[k]));
      let tableName = "訂單銷貨";
      if (statDay != "" && endDay != "") {
        tableName = tableName + statDay + "-" + endDay;
      }
      if (brand_id == 1) {
        tableName = "N牌" + tableName;
      }
      if (brand_id == 2) {
        tableName = "S牌" + tableName;
      }
      const [fileName, fileType, sheetName] = [tableName, "xlsx", tableName];

      const type = 'order'
     
     await toExcel({
        th,
        data,
        fileName,
        fileType,
        sheetName,
        type,
      });
     }else {
        const th = [
        "會員卡號",
        "會員姓名",
        "店櫃代碼",
        "店櫃名稱",
        "訂單日期時間",
        "訂單單號",
        "品名",
        "價格",
        
      ];
      const filterVal = [
        "card_number",
        "member_name",
        "shop_id",
        "shop_name",
        "create_datetime",
        "id",
        "item_name",
        "pack_paid",
        
      ];
      const data = datas.map((v) => filterVal.map((k) => v[k]));
      let tableName = "電子錢包訂單";
      if (statDay != "" && endDay != "") {
        tableName = tableName + statDay + "-" + endDay;
      }
      if (brand_id == 1) {
        tableName = "N牌" + tableName;
      }
      if (brand_id == 2) {
        tableName = "S牌" + tableName;
      }
      const [fileName, fileType, sheetName] = [tableName, "xlsx", tableName];

      const type = 'payorder'
     
     await toExcel({
        th,
        data,
        fileName,
        fileType,
        sheetName,
        type,
      });
     }
    
    },
    checkInput() {
      this.fetchShopList();
      
    },
    excelCheckInput() {
      
      this.excelQueryShop();
      
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `background-color: gray;color: #000;`;
      }
    },
    detailTabs(index, row) {
      this.orderKey = row._key;
      this.$emit("detailTabs", this.orderKey);
    },
  },
  created() {
    this.fetchMemberList();
    this.fetchShopList();
    this.excelQueryShop();
  },
};
</script>

<style lang="less" scoped></style>
